import * as React from "react";
const SvgFiRrSecondMedal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M15.011 19a1 1 0 0 1-1 1h-3.26a1.73 1.73 0 0 1-1.622-1.111 1.75 1.75 0 0 1 .464-1.934c.228-.205.509-.434.815-.682 1.153-.933 2.732-2.209 2.591-3.479-.049-.445-.483-.794-.988-.794a1 1 0 0 0-1 1 1 1 0 1 1-2 0c0-1.654 1.346-3 3-3 1.534 0 2.813 1.106 2.977 2.573.262 2.358-1.895 4.102-3.321 5.256l-.212.171h2.557a1 1 0 0 1 1 1zm7.294-16.131-3.242 6.57A8.95 8.95 0 0 1 21 15c0 4.963-4.037 9-9 9s-9-4.037-9-9a8.95 8.95 0 0 1 1.951-5.579L1.718 2.869a1.97 1.97 0 0 1 .095-1.93A1.97 1.97 0 0 1 3.502 0h3.009c1.534 0 2.909.854 3.588 2.23l1.86 3.772L12 6q.031.002.062.003l1.861-3.773A3.98 3.98 0 0 1 17.51 0h3.01c.692 0 1.324.351 1.689.939.366.588.402 1.309.096 1.93M3.502 2l2.942 5.934A9 9 0 0 1 9.86 6.268L8.305 3.115A1.99 1.99 0 0 0 6.511 2zM19 15c0-3.859-3.141-7-7-7-.199 0-.395.013-.59.03-3.583.302-6.409 3.31-6.409 6.97 0 3.859 3.141 7 7 7S19 18.859 19 15m1.512-13.016L17.511 2a1.99 1.99 0 0 0-1.794 1.115l-1.558 3.157a9 9 0 0 1 3.412 1.672z"
    />
  </svg>
);
export default SvgFiRrSecondMedal;
